import { resendConfirmSignUpCode } from "@services/auth";
import { useMutation } from "@tanstack/react-query";

export const useResendConfirmSignUpCode = (options: any = {}) => {
  return useMutation<any, any, { email: string }>({
    mutationFn: resendConfirmSignUpCode,
    ...options,
  });
};
